import { useEffect, useState } from "react";
import { Link } from 'react-router-dom';
import { getNewsInner } from "../Service/Api";

const News = () => {
    const [data, setData] = useState([]);
    const [filterData, setFilteredData] = useState([]);
    const [selectedYear, setSelectedYear] = useState(null);
    const [selectedMonth, setSelectedMonth] = useState("All");
    const [monthOptions, setMonthOptions] = useState(["All"]);
    const [yearRanges, setYearRanges] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

    useEffect(() => {
        const fetchData = async () => {
            const galleryData = await getNewsInner();
            setData(galleryData);

            const uniqueYears = Array.from(
                new Set(galleryData.flatMap((item) => {
                    if (item.fromDate) {
                        const year = new Date(item.fromDate).getFullYear();
                        return [year];
                    } else {
                        return [];
                    }
                }))
            );
            const uniqueYearRanges = uniqueYears.map(year => `${year}`);
            uniqueYearRanges.sort((a, b) => b - a);
            setYearRanges(uniqueYearRanges);

            const uniqueMonths = Array.from(
                new Set(galleryData.flatMap((item) => {
                    if (item.fromDate) {
                        const month = new Date(item.fromDate).getMonth() + 1;
                        return [month];
                    } else {
                        return [];
                    }
                }))
            );
            const monthOptions = uniqueMonths.sort((a, b) => a - b).map(month => monthNames[month - 1]);
            setMonthOptions(["All", ...monthOptions]);

            // Determine the current year and fallback year
            const currentYear = new Date().getFullYear();
            const previousYear = currentYear - 1;
            const currentYearDataAvailable = galleryData.some(item => new Date(item.fromDate).getFullYear() === currentYear);

            if (currentYearDataAvailable) {
                setSelectedYear(`${currentYear}`);
            } else {
                setSelectedYear(`${previousYear}`);
            }
        };
        fetchData();
    }, []);

    useEffect(() => {
        const filterByYearAndMonth = () => {
            let filteredData = data;

            let yearDataAvailable = false;

            if (selectedYear && selectedYear !== "All") {
                filteredData = filteredData.filter((item) => {
                    if (item.fromDate && item.fromDate.trim() !== "") {
                        const year = new Date(item.fromDate).getFullYear();
                        if (parseInt(selectedYear) === year) {
                            yearDataAvailable = true;
                            const month = new Date(item.fromDate).getMonth() + 1;
                            return (selectedMonth === "All" || parseInt(selectedMonth) === month);
                        }
                        return false;
                    } else {
                        return false;
                    }
                });

                if (!yearDataAvailable) {
                    const previousYear = (parseInt(selectedYear) - 1).toString();
                    setSelectedYear(previousYear);
                    return; // Exit to trigger a re-render with the previous year
                }
            } else {
                // Handle case where "All" is selected
                filteredData = filteredData.filter(item => item.fromDate);
            }

            // Filter by month
            if (selectedMonth !== "All") {
                filteredData = filteredData.filter((item) => {
                    if (item.fromDate && item.fromDate.trim() !== "") {
                        const month = new Date(item.fromDate).getMonth() + 1;
                        return parseInt(selectedMonth) === month;
                    } else {
                        return false;
                    }
                });
            }

            if (searchQuery) {
                filteredData = filteredData.filter((item) =>
                    item.title.toLowerCase().includes(searchQuery.toLowerCase())
                );
            }

            filteredData.sort((a, b) => new Date(b.date) - new Date(a.date));
            setFilteredData(filteredData);
        };

        filterByYearAndMonth();
    }, [selectedYear, selectedMonth, searchQuery, data]);

    const emptyArray = [
        {
            description: "Stay tuned for more information about latest updates.",
            attachments: ["director.jpg"]
        }
    ];

    return (
        <>
            <div className="breadcrumb">

                <h2> News</h2>
                <ul>
                    <li><Link to="/"> Home <i className="fas fa-angle-right"></i> </Link></li>
                    <li>|</li>
                    <li>News</li>
                </ul>
            </div>
            <div className="inner_page">
                <div className="container">
                    <div className="row tabs-dynamic">
                        <div className="col-md-3">
                            <div className="count-val">
                                <p>Total Count: {filterData.length}</p>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="month-selection">
                                <select
                                    value={selectedYear || "All"}
                                    onChange={(e) => setSelectedYear(e.target.value)}
                                    className="yearSelection">
                                    <option value={"All"}>All</option>
                                    {yearRanges.map((yr) => (
                                        <option key={yr} value={yr}>{yr}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="month-selection">
                                <select
                                    value={selectedMonth}
                                    onChange={(e) => setSelectedMonth(e.target.value)}
                                    className="monthSelect">
                                    {monthOptions.map((month, index) => (
                                        <option key={index} value={index + 1}>{month}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="searchBox">
                                <input
                                    type="text"
                                    id="myInput"
                                    name="name"
                                    value={searchQuery}
                                    onChange={(e) => setSearchQuery(e.target.value)}
                                    placeholder="Search Here.."
                                />
                            </div>
                        </div>
                    </div>
                    <div className="row event_news_inner">
                        {filterData.length > 0 ? (
                            filterData.map((item, index) => (
                                <div className="col-lg-6 col-md-12" key={index}>
                                    <div className="data_sec">

                                        <div className="data_scrol">
                                            <h3>{item.title}</h3>
                                            <p>{item.description}</p>
                                        </div>
                                        <div className="news-date">
                                            <p>{item.fromDate} <span>
                                                {item.attachments.length > 0 && (<Link to={`https://webapi.entab.info/api/image/${item?.attachments}`} target="_blank" className="read_class">Attachment <i className="fas fa-arrow-right"></i> </Link>)}
                                            </span></p>
                                        </div>

                                    </div>
                                </div>
                            ))
                        ) : (
                            emptyArray.map((data, index) => (
                                <div className="col-lg-6 col-md-12" key={index}>
                                    <div className="data_sec">
                                        <div className="data_scrol">
                                            <h3>News Heading - 1</h3>
                                            <p>Stay Tuned For More Updates</p>
                                        </div>
                                        <div className="news-date">
                                            <p>DD.MM.YYYY <span>

                                            </span></p>
                                        </div>
                                    </div>
                                </div>
                            ))
                        )}
                    </div>
                </div>
            </div>

        </>
    );
}

export default News;
